export default new class calculatorClass {
  constructor() {
    this.calculatorListClass = 'kalkulyator__list';
    this.calculatorItemClass = 'kalkulyator__item';
    this.calculatorSelectClass = 'kalkulyator__item-select';
    this.calculatorCheckedClass = 'checked';

    this.calculatorResetClass = 'kalkulyator__form-reset';
    this.sDefaultChoiceClass = '_default-choice';

    this.dataIDPrice = 'price';
    this.dataIDServerConfig = 'server-config';
    this.dataIDHddConfig = 'hdd-config';
    this.dataIDRamConfig = 'ram-config';
    this.dataIDNetworkConfig = 'network-config';
    this.dataIDlocationConfig = 'location-config';

    this.sTotalValue = '_total-value';
    this.sServerValue = '_server-value';
    this.sHddValue = '_hdd-value';
    this.sRamValue = '_ram-value';
    this.sNetworkValue = '_network-value';
    this.sLocationValue = '_location-value';

    this.sHddLine = '_hdd-line';
    this.sRamLine = '_ram-line';

    this.kalkulatorCardClass = 'kalkulyator__card';
    this.kalkulatorCardLimitedClass = 'kalkulyator__card-limited';
    this.viewMoreClass = 'view-more__btn';

    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    this.updatePrice();
    this.viewMore();

    $(document)
      .on('click', `.${this.calculatorItemClass}`, (event) => {
        this.updateSelect(event);
        this.updatePrice();
      });

    $(document)
      .on('click', `.${this.calculatorResetClass}`, () => {
        this.resetForm();
        this.updatePrice();
      });
  }

  viewMore() {
    $(document)
      .on('click', `.${this.viewMoreClass}`, (event) => {
        const parent = event.target.closest(`.${this.kalkulatorCardClass}`);
        // eslint-disable-next-line no-console
        console.log(parent);

        parent.classList.toggle(this.kalkulatorCardLimitedClass);
      });
  }

  resetForm() {
    const lists = document.querySelectorAll(`.${this.calculatorListClass}`);

    lists.forEach((list) => {
      const items = list.querySelectorAll(`.${this.calculatorSelectClass}`);

      items.forEach(item => item.classList.remove(this.calculatorCheckedClass));

      if (list.classList.contains(this.sDefaultChoiceClass) && items.length > 0) {
        items[0].classList.add(this.calculatorCheckedClass);
      }
    });
  }

  updateSelect(event) {
    const currentItem = event.currentTarget;
    const parent = event.target.closest(`.${this.calculatorListClass}`);
    const itemCollection = parent.querySelectorAll(`.${this.calculatorItemClass}`);

    itemCollection.forEach((obResultItem) => {
      const obCalculatorSelect = $(obResultItem).find(`.${this.calculatorSelectClass}`);
      obCalculatorSelect.removeClass(this.calculatorCheckedClass);
    });

    const obSelectItem = $(currentItem).find(`.${this.calculatorSelectClass}`);
    obSelectItem.addClass(this.calculatorCheckedClass);
  }

  updatePrice() {
    let totalPrice = 0;
    let sServerConfig = null;
    let sHddConfig = null;
    let sRamConfig = null;
    let sNetworkConfig = null;
    let sLocationConfig = null;

    $(`.${this.calculatorSelectClass}.${this.calculatorCheckedClass}`).each((index, el) => {
      const price = parseFloat($(el).data(this.dataIDPrice)) || 0;
      totalPrice += price;
      if ($(el).data(this.dataIDServerConfig)) {
        sServerConfig = $(el).data(this.dataIDServerConfig);
      }
      if ($(el).data(this.dataIDHddConfig)) {
        sHddConfig = $(el).data(this.dataIDHddConfig);
      }
      if ($(el).data(this.dataIDRamConfig)) {
        sRamConfig = $(el).data(this.dataIDRamConfig);
      }
      if ($(el).data(this.dataIDNetworkConfig)) {
        sNetworkConfig = $(el).data(this.dataIDNetworkConfig);
      }
      if ($(el).data(this.dataIDlocationConfig)) {
        sLocationConfig = $(el).data(this.dataIDlocationConfig);
      }
    });

    // eslint-disable-next-line max-len
    this.updateResultForm(totalPrice, sServerConfig, sHddConfig, sRamConfig, sNetworkConfig, sLocationConfig);
  }

  // eslint-disable-next-line max-len
  updateResultForm(totalPrice, sServerConfig, sHddConfig, sRamConfig, sNetworkConfig, sLocationConfig) {
    const totalValue = document.querySelector(`.${this.sTotalValue}`);
    totalValue.textContent = totalPrice;

    const serverValue = document.querySelector(`.${this.sServerValue}`);
    serverValue.textContent = sServerConfig;

    if (sHddConfig) {
      const hddValue = document.querySelector(`.${this.sHddValue}`);
      document.querySelector(`.${this.sHddLine}`).style.display = 'flex';
      hddValue.textContent = sHddConfig;
    } else {
      document.querySelector(`.${this.sHddLine}`).style.display = 'none';
    }

    if (sRamConfig) {
      const ramValue = document.querySelector(`.${this.sRamValue}`);
      document.querySelector(`.${this.sRamLine}`).style.display = 'flex';
      ramValue.textContent = sRamConfig;
    } else {
      document.querySelector(`.${this.sRamLine}`).style.display = 'none';
    }

    const networkValue = document.querySelector(`.${this.sNetworkValue}`);
    networkValue.textContent = sNetworkConfig;

    const locationValue = document.querySelector(`.${this.sLocationValue}`);
    locationValue.textContent = sLocationConfig;
  }
}();
